<div class="AmInputForm" [formGroup]="formGroup">
  <div class="AmInputForm-input" [ngClass]="{ 'AmInputForm-input--fullSize': inputFullSize }">
    <input
          [formControl]="textControl"
          [placeholder]="placeholder | translate"
          [currentFormGroup]="formGroup"
          [formControlName]="nameInput"
          [id]="nameInput"
          [isFloat]="false"
          [showNav]="true"
          appAmKeyboard
          autocomplete="off"
          class="form-control {{className}}"
          [maxlength]="maxlength"
          [ngClass]="{
              'input--error': (textControl?.touched && textControl.invalid),
              'am-input-rb': className == 'am-input-rb',
              'am-input': className == 'am-input'
          }"
          [type]="typeInput"
          [(ngModel)]="val"
          [nameList]="nameList"
          [readOnly]="readOnly"
          (change)="onTouchedInp()"
      >
    <div class="AmInputForm-label text-label" *ngIf="textControl" [ngClass]="{ 'AmInputForm-label--fullSize': inputFullSize }">
      {{ label | translate }}
    </div>
    <img [ngClass]="{'icon-close-full': inputFullSize, 'icon-close': !inputFullSize }"
      class="animate__animated animate__fadeIn" *ngIf="showArrowRed" src="./assets/images/forms/chevron-down.svg" alt="arrow">
  </div>
  <app-icon-form-correct
      [className]="classNameIcon"
      [fieldInput]="textControl"
      *ngIf="!inputFullSize"
  ></app-icon-form-correct>
  <app-form-error-message [ngStyle]="{'width': inputFullSize ? '100%': '24%'}"
      [fieldInput]="textControl"
      [errorRequired]="errorRequired"
      [errorPattern]="errorPattern"
      [className]="classNameMessage"
  ></app-form-error-message>
</div>
